import { useContext, useState } from 'react'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { SubCategoryContext } from '../../context api/SubCategory/SubCategoryContext'
import { useRestApi } from '../../lib/RestApi/useRestApi'
import { API_URL } from '../../shared/actions'

export const useSubCategory = () => {
  const [subcategory, setSubCategory] = useState(false)
  const { deleteNewSubCategory, getNewSubCategories } = useContext(SubCategoryContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)

  const { ADD, GET_ALL, UPDATE, GET_SINGLE_DATA, DELETE } = useRestApi(setLoading, 'SubCategory', 'SUBCATEGORY', 'GET_ALL_SUBCATEGORIES')
  const {
    SUBCATEGORY: { GET_ALL_SUBCATEGORIES, ADD_SUBCATEGORY, EDIT_SUBCATEGORY, GET_SUBCATEGORY, DELETE_MANY_SUBCATEGORY },
  } = API_URL

  const getAllSubCategory = async (dto = {}) => {
    GET_ALL(GET_ALL_SUBCATEGORIES, setPaginate, getNewSubCategories, dto)
  }

  const addSubCategory = (dto) => {
    ADD(ADD_SUBCATEGORY, dto)
  }

  const updateSubCategory = (dto) => {
    UPDATE(EDIT_SUBCATEGORY, dto)
  }

  const getSubCategory = (dto) => {
    GET_SINGLE_DATA(GET_SUBCATEGORY, setSubCategory, dto)
  }

  const deleteManySubCategory = (dto, setSelected = () => {}) => {
    DELETE(DELETE_MANY_SUBCATEGORY, dto, 'subcategoryId', setSelected, deleteNewSubCategory, 'GET_ALL_SUBCATEGORIES')
  }

  return {
    addSubCategory,
    getAllSubCategory,
    getSubCategory,
    subcategory,
    updateSubCategory,
    deleteManySubCategory,
    loading,
    paginate,
  }
}
